const scoreTemplate = {
  getScoreTemplateTypes: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{
          GetAllScoreTemplateTypes {
            Score_Template_Input_Type_Id
            Title
            Description
          }
        }`
      })
      .then(r => {
        return r.data.GetAllScoreTemplateInputTypes;
      });
  },
  getScoreTemplateInputTypes: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{
          GetAllScoreTemplateInputTypes {
            Score_Template_Input_Type_Id
            Title
            Description
            Order
          }
        }`
      })
      .then(r => {
        return r.data.GetAllScoreTemplateInputTypes;
      });
  },

  getMyScoreTemplates: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
          GetMyScoreTemplates(userId: ` +
          this.$store.getters.user.User_Id +
          `) {
            Score_Template_Id
            Title
            Organization_Id
            Score_Template_Type_Id
            Score_Template_Inputs{
              Request
              Order
              Input_Data
              Score_Template_Input_Type{
                Score_Template_Input_Type_Id
                Title
              }
            }
          }
        }`
      })
      .then(r => {
        return r.data.GetMyScoreTemplates;
      });
  },

  getMyManageScoreTemplates: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
          GetMyScoreTemplates(userId: ` +
          this.$store.getters.user.User_Id +
          `) {
            Score_Template_Id
            Title
            Organization_Id
            Score_Template_Type_Id
            Created_By
            Score_Template_Inputs{
              Request
              Order
              Input_Data
              Score_Template_Input_Type{
                Score_Template_Input_Type_Id
                Title
              }
            }
            Units{
              Title
              Description
              Num_Scores
            }
            Behavior_Trackers{
              Title
              Description
              Num_Scores
            }
          }
        }`
      })
      .then(r => {
        return r.data.GetMyScoreTemplates;
      });
  },

  getMyManageScoreTemplate: async function(scoreTemplateId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
          GetMyScoreTemplate(userId: ` +
          this.$store.getters.user.User_Id +
          `, scoreTemplateId: ` +
          parseInt(scoreTemplateId) +
          `d) {
            Score_Template_Id
            Title
            Organization_Id
            Score_Template_Type_Id
            Created_By
            Score_Template_Inputs{
              Request
              Order
              Input_Data
              Score_Template_Input_Type{
                Score_Template_Input_Type_Id
                Title
              }
            }
            Units{
              Title
              Description
              Num_Scores
            }
            Behavior_Trackers{
              Title
              Description
              Num_Scores
            }
          }
        }`
      })
      .then(r => {
        return r.data.GetMyScoreTemplate;
      });
  },

  createScoreTemplate: async function(templateToCreate) {
    const query = `
      mutation($title: String!, $organizationId: Int!, $scoreTemplateTypeId: Int!, $createdBy: Int! ) {
        CreateScoreTemplate(title: $title, organizationId: $organizationId, scoreTemplateTypeId: $scoreTemplateTypeId, createdBy: $createdBy) {
          Score_Template_Id
        }
      }`;
    const variables = {
      title: templateToCreate.Title,
      organizationId: parseInt(templateToCreate.Organization_Id),
      scoreTemplateTypeId: parseInt(templateToCreate.Score_Template_Type_Id),
      createdBy: parseInt(this.$store.getters.user.User_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      templateToCreate.Score_Template_Id =
        res.data.CreateScoreTemplate.Score_Template_Id;
      return templateToCreate;
    });
  },

  deleteScoreTemplate: async function(scoreTemplateId) {
    const query = `
      mutation($scoreTemplateId: Int!) {
        DELETESCORETEMPLATE(scoreTemplateId: $scoreTemplateId)
      }`;
    const variables = {
      scoreTemplateId: parseInt(scoreTemplateId)
    };
    return await this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.DELETESCORETEMPLATE);
  },

  updateScoreTemplateInputs: async function(templateInputs, templateId) {
    const query = `
      mutation($scoreTemplateId: Int!) {
        DELETESCORETEMPLATEINPUTS(scoreTemplateId: $scoreTemplateId)
      }`;
    const variables = {
      scoreTemplateId: parseInt(templateId)
    };
    await this.$store.getters.fetcher({ query, variables });
    return await this.$createScoreTemplateInputs(templateInputs, templateId);
  },

  createScoreTemplateInputs: async function(templateInputs, templateId) {
    const query = `
      mutation($templateInputs: [InputScoreTemplateInput]!, $templateId: Int!) {
        CreateScoreTemplateInputs(templateInputs: $templateInputs, templateId: $templateId) {
            Score_Template_Input_Id
            Request
            Input_Data
            Order
            Score_Template_Input_Type{
              Score_Template_Input_Type_Id
              Title
            }
        }
      }`;
    var inputs = [];
    templateInputs.forEach(input => {
      inputs.push({
        Request: input.Request,
        Order: parseInt(input.Order),
        Score_Template_Input_Type_Id: parseInt(
          input.Score_Template_Input_Type.Score_Template_Input_Type_Id
        ),
        Input_Data: JSON.stringify(input.Input_Data)
      });
    });
    const variables = {
      templateInputs: inputs,
      templateId: parseInt(templateId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.CreateScoreTemplateInputs);
  },

  updateScoreTemplate(scoreTemplatetoUpdate) {
    const query = `
      mutation($scoreTemplateId: Int!, $title: String!) {
        UpdateScoreTemplate(scoreTemplateId: $scoreTemplateId, title: $title) {
          Score_Template_Id
        }
      }`;
    const variables = {
      scoreTemplateId: parseInt(scoreTemplatetoUpdate.Score_Template_Id),
      title: scoreTemplatetoUpdate.Title
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(() => scoreTemplatetoUpdate);
  },

  getScoreTemplateInputSummary(scoreTemplateInput) {
    switch (
      parseInt(
        scoreTemplateInput.Score_Template_Input_Type
          .Score_Template_Input_Type_Id
      )
    ) {
      case 2:
      case 8:
        return scoreTemplateInput.Score_Template_Input_Type.Title;
      case 1:
        var outOf = "";
        try {
          outOf = JSON.parse(scoreTemplateInput.Input_Data).Out_Of;
        } catch {
          outOf = scoreTemplateInput.Input_Data.Out_Of;
        }
        return (
          scoreTemplateInput.Score_Template_Input_Type.Title.replace(
            /[()]/g,
            ""
          ) +
          ": " +
          outOf
        );
      default:
        return scoreTemplateInput.Score_Template_Input_Type.Title;
    }
  },

  getInputDefaultValue(input) {
    switch (
      input.Score_Template_Input_Type
        ? input.Score_Template_Input_Type.Score_Template_Input_Type_Id.toString()
        : input.Score_Template_Input_Type_Id.toString()
    ) {
      case "1":
      case "8":
        return 0;
      case "5":
        return { Occured: null, Explain: "" };
      case "7":
        return { Occured: null };
      case "2":
      default:
        return "";
    }
  },

  prettifyInput(input, inputTemplate = null) {
    switch (
      inputTemplate.Score_Template_Input_Type
        ? parseInt(
            inputTemplate.Score_Template_Input_Type.Score_Template_Input_Type_Id
          )
        : parseInt(inputTemplate.Score_Template_Input_Type_Id)
    ) {
      case 4:
        return (
          input +
          " - " +
          inputTemplate.Input_Data.Choices.find(d => d.Choice == input).Text
        );
      case 5:
        return input.Occured ? "Yes - " + input.Explain : "No";
      case 7:
        return input.Occured ? "Yes" : "No";
      default:
        console.log;
        return input;
    }
  }
};

export { scoreTemplate };
